import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { faInfoCircle } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Icon } from "@performyard/py-components";

import { NavChromeFixedContainer } from "../../../components/NavChromeFixedContainer";
import PageTitle from "../../../components/PageTitle";
import { LaunchWorkflowWizard } from "./LaunchWorkflowWizard";

import { useHideBackgroundJobsWatcher } from "../../../hooks/useHideBackgroundJobsWatcher";
import { useHideSubNav } from "../../../hooks/useHideSubNav";

import { getUserCompanyName } from "../../../selectors/app";

import { parseWorkflowsOrigin } from "../../../utils/workflowsBreadcrumbs";

import useWorkflowsPageGate from "../useWorkflowsPageGate";

const WORKFLOWS_PATH = "/company/workflows";

const LaunchWorkflowPage = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [originSearch] = useState(() => location.search);
	const companyName = useSelector(getUserCompanyName);

	const { isGateLoading, featureAvailable, canManage } = useWorkflowsPageGate();

	useHideSubNav(true);
	useHideBackgroundJobsWatcher(true);

	if (isGateLoading) {
		return null;
	}

	if (!featureAvailable) {
		return <Navigate to="/feature-disabled/" replace />;
	}

	if (!canManage) {
		return (
			<div className="p-6">
				<div className="flex w-[400px] gap-1.5 rounded-sm bg-primary-1 p-5">
					<Icon icon={faInfoCircle} size={20} color="primary-7" />
					<div className="font-semibold">Missing required permissions.</div>
				</div>
			</div>
		);
	}

	const origin = parseWorkflowsOrigin(originSearch);

	return (
		<>
			<PageTitle title={`Launch Workflow${companyName ? ` - ${companyName}` : ""} - PerformYard`} />
			<NavChromeFixedContainer>
				<LaunchWorkflowWizard
					onExit={() => navigate(origin.from)}
					onLaunched={() => navigate(WORKFLOWS_PATH)}
				/>
			</NavChromeFixedContainer>
		</>
	);
};

export default LaunchWorkflowPage;
